<template>
    <div>
        <div class="main-content bg-white" v-if="$currentUser.role != 'admin' && $currentUser.role != 'account'">
            <span class="alert-danger">У вас нет доступа к этой странице.</span>
        </div>
        <div class="main-content bg-white" v-if="$currentUser.role == 'admin' || $currentUser.role == 'account'">
            <div class="page-header">
                <h3 class="page-title">Конверсии</h3>
            </div>

            <div class="row mb-2">
                <div :key="dateRange" class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <b-button-group v-if="isXl" class="datePickerXl ">
                        <date-range-picker
                                ref="picker"
                                :locale-data="dateRangeLocalFormat"
                                v-model="range"
                                :opens="'right'"
                                :ranges="dateRanges"
                                @update="selectRange($event)">
                            <template v-slot:input="picker" style="min-width: 350px;!important;">
                                {{ range.startDate | formatDateRange }} - {{ range.endDate | formatDateRange  }}
                            </template>
                        </date-range-picker>
                        <b-button size="sm" variant="primary">
                            <i class="icon-fa icon-fa-calendar-check-o"></i>
                        </b-button>
                    </b-button-group>
                    <b-input-group :key="dateRange" v-if="!isXl">
                        <div></div>
                        <b-input-group-append>
                            <datepicker input-class="form-control dateFrom"
                                        class="date dateLeft"
                                        size="sm"
                                        v-model="range.startDate"
                                        monday-first
                                        :language="ru"
                                        placeholder="С:">
                            </datepicker>
                            <datepicker input-class="form-control dateTo"
                                        class="date dateRight"
                                        monday-first
                                        size="sm"
                                        v-model="range.endDate"
                                        :language="ru"
                                        placeholder="По:">
                            </datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <v-select :options="selectOffers" :filter="filterOffers"
                              v-model="search"
                              required label="title"
                              placeholder="Оффер"
                              multiple>
                        <span slot="no-options">Совпадений не найдено.</span>
                        <template slot="option" slot-scope="option">
                            <span>({{option.id}}) {{ option.title }}</span>
                        </template>
                    </v-select>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <v-select

                            label="name"
                            placeholder="Аккаунт"
                            :options="accountManagers"
                            :reduce="accountManager => accountManager.id"
                            multiple
                            v-model="account">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <v-select
                            id="source_group"
                            label="name"
                            placeholder="Группа источника"
                            :options="sourceGroups"
                            :reduce="sourceGroup => sourceGroup.id"
                            multiple
                            v-model="selectedSourceGroups">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" v-if="$currentUser.role == 'admin' || $currentUser.role == 'leader'">
                    <v-select label="name" :options="users"
                              :filter="filterBuyers"
                              required v-model="user" placeholder="Медиабайер" multiple>
                        <span slot="no-options">Совпадений не найдено.</span>
                        <template slot="option" slot-scope="option">
                            <span>{{ option.name }} ({{option.network_partner_id}})</span>
                        </template>
                    </v-select>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <v-select :options="types"
                              placeholder="Тип"
                              :clearable="false"
                              :searchable="false"
                              multiple
                              v-model="type">
                    </v-select>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <v-select
                            placeholder="Сейл"
                            label="name"
                            :options="salesManagers"
                            :reduce="manager => manager.id"
                            required
                            multiple
                            v-model="selectedSalesManagers">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <v-select
                            :options="advertisers"
                            placeholder="Рекламодатель"
                            :reduce="advertiser => advertiser.value"
                            required
                            multiple
                            v-model="selectedAdvertisers">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-sm-5 col-md-3 col-lg-3 col-xl-2 mb-2 applyButton">
                    <b-input-group>
                        <div></div>
                        <b-input-group-append>
                            <b-btn size="sm" text="Search" variant="success"
                                   class="mainButton"
                                   style="margin-right: 4px; border-top-left-radius: 0.2rem; border-bottom-left-radius: 0.2rem;"
                                   @click="getConversions(1, {sortBy: sortBy, sortDesc: sortDesc}, search, true)">
                                Применить
                                <!--<i class="icon-fa icon-fa-search"></i>-->
                            </b-btn>
                            <b-btn size="sm" variant="outline-danger" class="mainButton" @click="resetFilters">Очистить
                                <!--<i class="icon-fa icon-fa-times"></i>-->
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-lg-12">
                    <b-button variant="info" v-on:click="openDataUploadModal" size="sm">
                       Загрузить xls <i class="icon-fa icon-fa-upload"></i>
                    </b-button>
                    <b-button variant="warning" size="sm">
                        <a
                           v-bind:href="getExcelParamsString()">
                            Выгрузить xls <i class="icon-fa icon-fa-upload"></i>
                        </a>
                    </b-button>
                    <b-button variant="info" size="sm"
                              @click.stop="openBuyersTable()">
                        Список байеров
                    </b-button>
                    <b-button v-if="!isSelectAll" variant="warning" size="sm"
                              v-on:click="selectAll()">
                        Выделить все
                    </b-button>
                    <b-button v-if="isSelectAll" variant="info" size="sm"
                              v-on:click="diselectAll()">
                        Снять выделение
                    </b-button>
                  <b-button variant="success" size="sm"
                            v-on:click="editSelected()">
                    Редактировать выделенное
                  </b-button>
                    <b-button variant="danger" size="sm"

                              v-on:click="deleteSelected()">
                       Удалить выделенное
                    </b-button>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
                        <span>{{alertText}}</span>
                    </b-alert>
                    <b-alert v-model="showSuccessAlert" variant="success" dismissible>
                        <span>{{successAlertText}}</span>
                    </b-alert>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div v-if="!isMobile">
                        <b-table hover responsive bordered
                                 small
                                 :busy="isBusy"
                                 :items="conversions"
                                 :fields="fields"
                                 no-local-sorting
                                 :sort-by.sync="sortBy"
                                 @sort-changed="getConversions(1, $event, search)"
                                 :sort-desc.sync="sortDesc"
                                 :sort-direction="sortDirection">
                            <template v-slot:cell(actions)="row">
                                <div class="">
                                    <b-button size="sm" class="btn btn-warning"
                                              @click.stop="edit(row)">
                                        <i class="icon-fa icon-fa-edit"></i>
                                    </b-button>
                                </div>
                            </template>
                            <template v-slot:cell(source_group_id)="row">
                                <span>{{row.item.source_group_name}}</span>
                            </template>
                            <template v-slot:cell(buyer_name)="row">
                                <span>{{row.item.buyer_name}} ({{row.item.buyer_id}})</span>
                            </template>

                            <template v-slot:cell(select)="row">
                                <div class="">
                                    <b-form-checkbox
                                            v-model="selectedConversions[row.item.id]"
                                            v-on:change="selectConversion($event, row.item.id)">
                                    </b-form-checkbox>
                                </div>
                            </template>
                            <template slot="bottom-row"
                                      slot-scope="data">
                                <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                                <td>
                                    <b>Total:</b>
                                    <div v-for="(field, i) in total_amount">
                                        <span>{{field.currency}}: </span> <span>{{field.amount}}</span>
                                    </div>
                                </td>
                                <td></td><td></td><td></td>
                            </template>
                        </b-table>
                    </div>
                    <div v-if="isMobile">
                        <b-table hover responsive bordered stacked
                                 small
                                 :busy="isBusy"
                                 :items="conversions"
                                 :fields="fields"
                                 no-local-sorting
                                 :sort-by.sync="sortBy"
                                 @sort-changed="getConversions(1, $event, search)"
                                 :sort-desc.sync="sortDesc"
                                 :sort-direction="sortDirection">
                            <template v-slot:cell(actions)="row">
                                <div class="">
                                    <b-button size="sm" class="btn btn-warning"
                                              @click.stop="edit(row)">
                                        <i class="icon-fa icon-fa-edit"></i>
                                    </b-button>
                                </div>
                            </template>
                            <template v-slot:cell(source_group_name)="row">
                                <span>{{row.item.source_group_name}}</span>
                            </template>
                            <template v-slot:cell(select)="row">
                                <div class="">
                                    <b-form-checkbox
                                            v-model="selectedConversions[row.item.id]"
                                            v-on:change="selectConversion($event, row.item.id)">
                                    </b-form-checkbox>
                                </div>
                            </template>
                            <template slot="bottom-row"
                                      slot-scope="data">
                                <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                                <td>
                                    <b>Total:</b>
                                    <div v-for="(field, i) in total_amount">
                                        <span>{{field.currency}}: </span> <span>{{field.amount}}</span>
                                    </div>
                                </td>
                                <td></td><td></td><td></td>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-5">
                    <div class="" role="status" aria-live="polite">Всего записей: {{ pager.total }}</div>
                </div>
                <div class="col-sm-7">
                    <div class="float-right">
                        <nav aria-label="Page navigation">
                            <ul class="pagination justify-content-center">
                                <b-pagination size="sm" :total-rows="pager.total"
                                              v-model="pager.current_page"
                                              v-on:change="getConversions($event, {sortBy: sortBy, sortDesc: sortDesc}, search)"
                                              :per-page="pager.per_page"></b-pagination>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        <b-modal ref="EditConversionModal"
                 :no-close-on-backdrop="true"
                 :no-enforce-focus="true"
                 :no-close-on-esc="true"
                 @hide="getConversions()"
                 id="EditConversionModal" size="md" title="Редактировать конверсию" hide-footer>
            <EditConversionModal v-bind:conversion="selectedConversion"></EditConversionModal>
        </b-modal>
      <b-modal ref="MassEditConversionsModal"
               :no-close-on-backdrop="true"
               :no-enforce-focus="true"
               :no-close-on-esc="true"
               @hide="getConversions()"
               id="EditConversionModal" size="md" title="Редактировать конверсии" hide-footer>
        <MassEditConversionsModal v-bind:conversions="selectedConversions"></MassEditConversionsModal>
      </b-modal>
        <b-modal ref="BuyersTableModal"
                 :no-close-on-backdrop="true"
                 :no-enforce-focus="true"
                 :no-close-on-esc="true"
                 id="BuyersTableModal" size="md" title="Список байеров" hide-footer>
            <BuyersTableModal></BuyersTableModal>
        </b-modal>
        <b-modal id="uploadDataModal" ref="uploadDataModal"
                 @ok="uploadData"
                 @hidden="uploadDataModal.file = null"
                 :ok-disabled="! Boolean(uploadDataModal.file)"
                 ok-title="Загрузить"
                 cancel-title="Отмена"
                 title="Загрузить данные">
            <span class="alert-danger" v-for="error in uploadDataModal.errors">{{ error }}</span>
            <form class="mt-2">
                <b-form-group label="Выберите файл или перенесите сюда">
                    <b-form-file
                            v-model="uploadDataModal.file"
                            :state="Boolean(uploadDataModal.file)"
                            accept=".xlsx, .xls"
                            size="sm"
                            placeholder="Файл не выбран"
                            drop-placeholder="Drop file here..."
                    ></b-form-file>
                </b-form-group>
            </form>
        </b-modal>
    </div>
</template>
<script>
    import {ru} from '../../services/customLocaleDatepicker'
    import Ls from '../../services/ls'

    import ConversionsService from '../../services/conversionsDataService'
    import OffersService from '../../services/offersDataService'
    import advertiserFormMixin from "./mixins/Advertiser/advertiserFormMixin";
    import salesManagerFormMixin from "./mixins/SalesManager/salesManagerFormMixin";
    import accountManagerFormMixin from "./mixins/AccountManager/accountManagerFormMixin";
    import reportMixin from "./mixins/reportMixin";
    import EditConversionModal from './modals/EditConversionModal'
    import MassEditConversionsModal from './modals/MassUpdateConversionsModal'
    import BuyersTableModal from './modals/BuyersTableModal'
    import saveFiltersMixin from "./mixins/saveFiltersMixin";
    import DateRangePicker from 'vue2-daterange-picker'

    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import vue2DateRangePickerMixin from "./mixins/vue2DateRangePickerMixin";

    export default {
        name: 'conversions',
        components: {
            EditConversionModal: EditConversionModal,
            BuyersTableModal: BuyersTableModal,
            DateRangePicker: DateRangePicker,
            MassEditConversionsModal: MassEditConversionsModal
        },
        mixins:[
            advertiserFormMixin,
            salesManagerFormMixin,
            accountManagerFormMixin,
            reportMixin,
            saveFiltersMixin,
            vue2DateRangePickerMixin
        ],
        data() {
            return {
                conversions: [],
                pager: {},
                pageSize: 50,
                isSelectAll: false,
                advertisers: [],
                selectedAdvertisers: [],
                salesManagers: [],
                selectedSalesManagers: [],
                groups: [],
                group: [],
                users: [],
                user: [],
                account: this.$currentUser.role == 'account' ? [this.$currentUser.id] : [],
                selectOffers: [],
                ru: ru,
                fields: [
                    {
                        key: 'select',
                        label: 'Select',
                        tdAttr: {'align': 'center'}
                    },
                    {
                        key: 'loading_date',
                        label: 'Loading date',
                        sortable: true
                    },
                    {
                        key: 'offer_title',
                        label: 'Offer',
                        sortable: true
                    },
                    {
                        key: 'type',
                        label: 'Offer type',
                        sortable: true
                    },
                    {
                        key: 'platform_name',
                        label: 'Platform',
                        sortable: true
                    },
                    {
                        key: 'buyer_id',
                        label: 'Buyer ID',
                        sortable: true
                    },
                    {
                        key: 'buyer_name',
                        label: 'Buyer',
                        sortable: true
                    },
                    {
                        key: 'legal_title',
                        label: 'Advertiser',
                        sortable: true
                    },
                    {
                        key: 'sales_managers',
                        label: 'Sales Managers',
                        sortable: true
                    },
                    {
                        key: 'account_manager_name',
                        label: 'Account Manager',
                        sortable: true
                    },
                    {
                        key: 'amount',
                        label: 'Amount',
                        sortable: true
                    },
                    {
                        key: 'currency',
                        label: 'Currency',
                        sortable: true
                    },
                    {
                        key: 'source_group_name',
                        label: 'Source group',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: 'Actions',
                        tdAttr: {'align': 'center'}
                    },
                ],
                search: '',
                sortBy: 'loading_date',
                sortDesc: true,
                sortDirection: 'desc',
                isMobile: false,
                window: {
                    width: 0,
                    height: 0
                },
                isXl: false,
                uploadDataModal: {
                    errors: [],
                    file: null
                },
                showSuccessAlert: false,
                successAlertText: '',
                showDismissibleAlert: false,
                alertText: '',
                selectedConversions: {},
                accountManagers: [],
                isBusy: true,
                total_amount: [],
                selectedConversion: null,
                sourceGroups: [],
                selectedSourceGroups: [],
                savedFiltersName: 'conversions',
            }
        },
        methods: {
            getConversions (page, sort,search, isFilter) {
                if (this.useSavedFilters == true) {
                    let filters = this.getFilters(this.savedFiltersName)

                    if (filters) {
                        page = filters.page
                        sort = filters.sort
                        search = filters.search

                        this.passFilters(filters)
                    }
                }
                if (isFilter) {
                    this.isBusy = true;
                }
                if (!page) {
                    page = 1;
                }

                if (!sort) {
                    sort = this;
                }

                let range = {
                    startDate: this.range.startDate ? this.convertISODate(this.range.startDate).toISOString().substring(0, 10) : null,
                    endDate: this.range.endDate ? this.convertISODate(this.range.endDate).toISOString().substring(0, 10) : null
                };

                let userArray = [];

                if (this.user && this.user.length != 0) {
                    this.user.forEach(function (userItem) {
                        userArray.push(userItem.id)
                    });
                } else {
                    userArray.push('all')
                }

                if (!search) {
                    search = this.search;
                }

                let searchArray = [];

                if (search.length > 0) {
                    search.forEach(function (searchItem) {
                        searchArray.push(searchItem.id)
                    });
                } else {
                    searchArray = null;
                }

                if (this.isMobile) {
                    this.pageSize = 10
                }
                let params = {
                    page: page,
                    sortBy: sort.sortBy,
                    sortDesc: sort.sortDesc,
                    search: searchArray ? searchArray.toString() : '',
                    start: range.startDate,
                    end: range.endDate,
                    user: userArray.toString(),
                    pageSize: this.pageSize,
                    // group: this.group.toString(),
                    type: this.getCurrentOfferTypes().toString(),
                    account: this.account.toString(),
                    sourceGroups: this.selectedSourceGroups.toString(),
                    advertisers: this.selectedAdvertisers.length !== 0 ? this.selectedAdvertisers.toString() : null,
                    salesManagers: this.selectedSalesManagers.length !== 0 ? this.selectedSalesManagers.toString() : null,
                }
                let filtersObject = this.prepareFiltersObject(page, sort, search)

                this.saveFilters(this.savedFiltersName, this.stringify(filtersObject))

                ConversionsService.getConversions(params)
                    .then(conversions => {
                        this.pager = conversions.conversions;
                        this.conversions = conversions.conversions.data
                        this.total_amount = conversions.total_amount
                        this.useSavedFilters = false
                        this.isBusy = false;
                    })

            },
            prepareFiltersObject(page, sort, search) {
                let object = {
                    page: page,
                    sort: {sortBy: sort.sortBy, sortDesc: sort.sortDesc},
                    search: search,
                    user: this.user,
                    type: this.type,
                    account: this.account,
                    selectedSourceGroups: this.selectedSourceGroups,
                    selectedAdvertisers: this.selectedAdvertisers,
                    selectedSalesManagers: this.selectedSalesManagers,
                    pageSize: this.pageSize,
                    range: this.range,
                }

                return object;
            },
            passFilters(filters) {
                this.range = this.dateConvert(filters.range.startDate, filters.range.endDate)
                this.search = filters.search
                this.user = filters.user
                this.type = filters.type
                this.account = filters.account
                this.selectedSourceGroups = filters.selectedSourceGroups
                this.selectedAdvertisers = filters.selectedAdvertisers
                this.selectedSalesManagers = filters.selectedSalesManagers
                this.pageSize = filters.pageSize
            },
            getExcelParamsString() {
                let range = {
                    startDate: this.range.startDate ? this.convertISODate(this.range.startDate).toISOString().substring(0, 10) : null,
                    endDate: this.range.endDate ? this.convertISODate(this.range.endDate).toISOString().substring(0, 10) : null
                };

                let userArray = [];

                if (this.user && this.user.length != 0) {
                    this.user.forEach(function (userItem) {
                        userArray.push(userItem.id)
                    });
                } else {
                    userArray.push('all')
                }

                let searchArray = [];

                if (this.search.length > 0) {
                    this.search.forEach(function (searchItem) {
                        searchArray.push(searchItem.id)
                    });
                } else {
                    searchArray = null;
                }

                let params = {
                    token: Ls.get('auth.token'),
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc,
                    search: searchArray ? searchArray.toString() : '',
                    start: range.startDate,
                    end: range.endDate,
                    user: userArray.toString(),
                    type: this.getCurrentOfferTypes().toString(),
                    account: this.account.toString(),
                    sourceGroups: this.selectedSourceGroups.toString(),
                    advertisers: this.selectedAdvertisers.length !== 0 ? this.selectedAdvertisers.toString() : null,
                    salesManagers: this.selectedSalesManagers.length !== 0 ? this.selectedSalesManagers.toString() : null,
                }

                return '/conversions/export?' + new URLSearchParams(params).toString();
            },
            selectConversion (e, id) {
                if (e) {
                    this.selectedConversions[id] = true
                    // this.selectedConversions.push(id)
                } else {
                    this.selectedConversions[id] = false
                    // let index = this.selectedConversions.indexOf(id);
                    // this.selectedConversions.splice(index, 1);
                }
            },
            getOffersForSelect() {
                let sort = {
                    sortBy: 'created_at',
                    sortDesc: true,
                }

                let range = {
                    startDate: null,
                    endDate: null
                }
                let user = null;

                OffersService.getOffers(1, sort, null, range, user, true)
                    .then(function (response) {
                        this.selectOffers = response;

                    }.bind(this))
            },
            getGroups() {
                ConversionsService.getSourceGroups()
                    .then(function (groups) {
                        this.sourceGroups = groups;
                    }.bind(this))
            },
            resetFilters() {
                this.group = [];
                this.type = [];
                this.account = []
                this.search = [];
                this.user = []
                this.selectedAdvertisers = []
                this.selectedSalesManagers = []

                this.selectedSourceGroups = []
                this.range = {
                    startDate: null,
                    endDate: null
                };

                //re-initialize element
                this.dateRange++;

                this.getConversions();
            },
            selectRange(event) {
                this.range = event;
            },
            deleteSelected() {
                let selectedConversionsArray = []

                Object.keys(this.selectedConversions).forEach(function(key){
                    if (this.selectedConversions[key]) {
                        selectedConversionsArray.push(key)
                        this.selectedConversions[key] = false
                    }

                }.bind(this))

                ConversionsService.deleteConversions(selectedConversionsArray)
                    .then(conversions => {
                       this.getConversions()
                        this.diselectAll()
                    })
            },
            editSelected() {
              this.$refs.MassEditConversionsModal.show()
            },
            filterOffers(options, search) {
                if (search) {
                    return options.filter(option => {
                        return option.title.toLowerCase().indexOf(search.toLowerCase()) >= 0 || option.id.toString().indexOf(search.toString()) >= 0;
                    });
                }
            },
          filterBuyers(options, search) {
            if (search) {
              return options.filter(option => {
                return option.name.toLowerCase().indexOf(search.toLowerCase()) >= 0 || option.network_partner_id.toString().indexOf(search.toString()) >= 0;
              });
            }
          },
            getUsersWithPartnerNetworkId() {
                ConversionsService.getUsersWithPartnerNetworkId()
                    .then(users => {
                        this.users = users
                    })
            },
            selectAll() {
                this.isSelectAll = true

                this.conversions.forEach(function (item) {
                    this.selectedConversions[item.id] = true
                }.bind(this))
            },
            diselectAll() {
                this.isSelectAll = false

                this.conversions.forEach(function (item) {
                    this.selectedConversions[item.id] = false
                }.bind(this))
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;

                if (this.window.width < 415) {
                    this.isMobile = true
                } else {
                    this.isMobile = false
                }

                if (this.window.width > 1199) {
                    this.isXl = true
                } else {
                    this.isXl = false
                }
            },
            edit(item) {
                this.selectedConversion = item
                this.$refs.EditConversionModal.show()
            },
            openBuyersTable(item) {
                this.$refs.BuyersTableModal.show()
            },
            openDataUploadModal() {
                this.uploadDataModal.errors = []
                this.uploadDataModal.file = null
                this.showSuccessAlert = false
                this.successAlertText = ''
                this.$refs.uploadDataModal.show()
            },
            async uploadData (event) {
                event.preventDefault()
                this.uploadDataModal.errors = []
                if(this.uploadDataModal.file === null) {
                    this.uploadDataModal.errors.push('Выберите файл')

                    return
                }

                let formData = new FormData()
                formData.append('conversions_file', this.uploadDataModal.file)

                let response = await ConversionsService.uploadConversion(formData)
                if(response.status === true) {
                    this.showSuccessAlert = true
                    this.successAlertText = 'Файл успешно загружен.'
                    this.$refs.uploadDataModal.hide()

                    this.getConversions()
                    this.getGroups()
                }

                this.uploadDataModal.errors = response.errors
            },
        },
        beforeMount() {
            this.useSavedFilters = true
            this.getConversions()

            // this.getGroups();
            this.getOffersForSelect();
            this.getAdvertisers();
            this.getActiveSalesManagers();
            this.getActiveAccountManagers();
            this.getUsersWithPartnerNetworkId()
            this.getGroups()
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
    }
</script>
<style>
    .btn i {
        text-align: center !important;
    }


    .vdp-datepicker input {
        background-color: white !important;
        width: 100% !important;
    }

    .dateFrom {
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
        height: 35px;
    }

    .dateTo {
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
        height: 35px;
    }

    .mainButton {
        width: 100%;
    }

    .date {
        width: 100%;
    }
    .datePickerXl {
        min-width: 100% !important;
        max-width: 100% !important;
    }
    .input-group-append {
        width: 100%;
    }

    .input-date {
        border-top-left-radius: 0.2rem !important;
        border-bottom-left-radius: 0.2rem !important;
    }


    .popover-body {
        max-height: 200px;
        overflow: scroll;
    }

    .mainButton {
        width: 100%;
    }

    .table-sm th {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .table.b-table > tfoot > tr > th[aria-sort]::before, .table.b-table > thead > tr > th[aria-sort]::before {
        padding-left: 5px;
        width: .2em;
    }

    .reportrange-text {
        font-size: 0.9rem;
        min-width: 150px;
        width: 110%!important;
    }

    @media (max-width: 576px) {
        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 768px) {
        .dateLeft .vdp-datepicker__calendar {
            right: 0 !important;
        }

        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 1200px) {
        .myOffers {
            max-width: 14.66666667% !important;
        }

        .input-date {
            width: 146px !important;
        }
    }

    @media (min-width: 1300px) {
        .input-date {
            width: 160px !important;
        }
    }

    @media (min-width: 1400px) {
        .input-date {
            width: 170px !important;
        }

        .myOffers {
            max-width: 12.66666667% !important;
        }
    }

    @media (min-width: 1500px) {
        .input-date {
            width: 190px !important;
        }
    }

    @media (min-width: 1600px) {
        .input-date {
            width: 200px !important;
        }

        .myOffers {
            max-width: 11.66666667% !important;
        }
    }

    @media (min-width: 1700px) {
        .input-date {
            width: 220px !important;
        }
    }

    @media (min-width: 1800px) {
        .input-date {
            width: 230px !important;
        }
    }

    @media (min-width: 1900px) {
        .input-date {
            width: 240px !important;
        }

        .myOffers {
            max-width: 9.66666667% !important;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/views/front/Conversions.vue